<div class="setup-service-box">
  <ion-grid>
    <ion-row>
      <ion-col size="3" class="setup-box-icon">
        <ion-icon [name]="iconName"></ion-icon>
      </ion-col>
      <ion-col size="auto" class="setup-box-text">
        <div class="setup-box-header">{{ header }}</div>
        <div class="setup-box-deviceName">{{ title }}</div>
        <div class="setup-box-details">Plan details</div>
      </ion-col>
      <ion-col size="3" class="setup-box-pricing">
        <div class="setup-box-service-currency">{{ currency }}</div>
        <div class="setup-box-service-amount">${{ amount }}</div>
        <div class="setup-box-service-interval">{{ interval }}</div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
